import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  width: 100%;
  padding: 24px;
`

export const title: Interpolation<Theme> = css`
  font-weight: 700;
  margin-bottom: 24px;
`

export const link: Interpolation<Theme> = (theme: Theme) => css`
  color: ${theme.colors.blueHover};
`

export const tablesWrapper: Interpolation<Theme> = css`
  margin-top: 24px;
  display: flex;
  gap: 15px;
  align-items: flex-start;
`

export const tableHeader: Interpolation<Theme> = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
`

export const tableTitle: Interpolation<Theme> = css`
  font-weight: 600;
`

export const countWrapper: Interpolation<Theme> = css`
  position: relative;
  height: 20px;
`

export const countTitle: Interpolation<Theme> = css`
  position: absolute;
  right: 0;
  top: 0;
  white-space: nowrap;
`

export const countValue: Interpolation<Theme> = css`
  text-align: right;
`

export const categoriesWrapper: Interpolation<Theme> = css`
  flex: 1;
`

export const categoriesTable: Interpolation<Theme> = css`
  .table-header .table-cell {
    font-weight: 700;
  }

  .table-row {
    padding: 5px 12px;
  }
`

export const questionBanksWrapper: Interpolation<Theme> = (theme) => css`
  flex: 1;
  border-radius: 20px;
  background: ${theme.backgrounds.backgroundThree};
  padding: 14px;
`

export const questionBanksTable: Interpolation<Theme> = (theme) => css`
  .table-header {
    background: ${theme.backgrounds.backgroundFour};

    .table-cell {
      font-weight: 700;
    }
  }

  .table-row {
    padding: 5px 12px;
  }
`
